import Request from './request';
import consts from "@/consts.js";

async function fetch(data) {
    return Request('get', "api/food-behavior/", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/food-behavior/select", data, false, false, true);
}

async function save(id,data){// 编辑或新建数据（有id为编辑，没有id为新建）
    if(id){
        return Request('post', "api/food-behavior/edit?id=" + id, data);
    } else {
        return Request('post', "api/food-behavior/add" , data);
    }
}

async function del(id){// 删除数据
    return Request('get', "api/food-behavior/delete/", id ? { id: id} : {});
}

export default {
    fetch,
    fetchAllForSelect,
    save,
    del,
};